export const welcomeCopy = {
  brand: {
    name: 'EKOM',
    tagline: 'Catalog Intelligence',
  },
  hero: 'Connect your catalog',
  subhead: 'Import your own product CSV — any vertical, any fields.',
  upload: {
    title: 'Import your CSV',
    body: 'Upload a product catalog CSV. The agent will analyze your data and generate real findings based on what it finds.',
    cta: 'Choose file',
    dragHint: 'or drop a file here',
    accept: '.csv,.xlsx',
  },
  errors: {
    tooLarge: 'File is too large. Maximum size is 100MB.',
    wrongType: 'Only CSV and XLSX files are supported.',
    generic: 'Upload failed. Please try again.',
  },
  uploading: 'Uploading',
} as const;

export const MAX_UPLOAD_BYTES = 100 * 1024 * 1024; // 100MB
export const PROGRESS_HINT_THRESHOLD_BYTES = 5 * 1024 * 1024; // 5MB
export const ACCEPTED_FILE_EXTENSIONS = ['.csv', '.xlsx'] as const;
